import { render } from "./IconArrowRight.vue?vue&type=template&id=5e867e82"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconArrowRight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e867e82"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e867e82', __exports__)) {
    api.reload('5e867e82', __exports__)
  }
  
  module.hot.accept("./IconArrowRight.vue?vue&type=template&id=5e867e82", () => {
    api.rerender('5e867e82', render)
  })

}


export default __exports__